import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_ADD_SITE_TEXTS_CONFIG,
  ACTION_ADD_SITE_TEXTS_TRANSLATIONS,
  ACTION_ADD_SITE_TEXTS_DEFAULT_TRANSLATIONS,

  ACTION_DELETE_SITE_TEXTS__REQUEST,
  ACTION_DELETE_SITE_TEXTS__FAIL,
  ACTION_DELETE_SITE_TEXTS__SUCCESS,
} from '../actionTypes';


const siteTextsConfigs = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITE_TEXTS_CONFIG:
      return action.payload.config;

    default:
      return state;
  }
};

const siteTextsTranslations = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITE_TEXTS_TRANSLATIONS: {
      const translations = {};

      action.payload.translations.forEach(({
        key,
        lang,
        status,
        value,
      }) => {
        if (typeof translations[key] === 'undefined') {
          translations[key] = {};
        }
        translations[key][lang] = { value, status };
      });

      return translations;
    }

    default:
      return state;
  }
};

const siteTextDefaultTranslations = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITE_TEXTS_DEFAULT_TRANSLATIONS:
      return action.payload.translations;

    default:
      return state;
  }
};

const isLangKeyBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_TEXTS__REQUEST:
      return {
        ...state,
        [action.payload.langKey]: {
          ...state[action.payload.langKey], [action.payload.lang]: true,
        },
      };

    case ACTION_DELETE_SITE_TEXTS__FAIL:
    case ACTION_DELETE_SITE_TEXTS__SUCCESS:
      return {
        ...state,
        [action.payload.langKey]: {
          ...state[action.payload.langKey], [action.payload.lang]: false,
        },
      };

    default:
      return state;
  }
};

export default combineReducers({
  siteTextsConfigs,
  siteTextsTranslations,
  siteTextDefaultTranslations,
  isLangKeyBeingDeleted,
  errors,
});
